import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { departmentActions } from "../../store/department-store/department-slice";
import { uiActions } from "../../store/ui-slice";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect } from "react";
import { getTokenInfo } from "../../utils/Guard";

let restartPage = false; 

const DepartmentForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const department = props.department;
  const isValid = useSelector((state) => state.department.departmentValidation);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);


  const onChangeHandler = (id, value) => {
    dispatch(departmentActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(departmentActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(departmentActions.setFieldValid({ id, value: false }));
    }
  };
  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      department.id > 0 &&
      restartPage
    ) {
      dispatch(departmentActions.restartState());
      window.location.href = "/departments";
    }
  }, [department.id, dispatch, navigate, notification]);
  
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (department.name === "") {
      dispatch(departmentActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(props.actionDepartment(department, userInfo.Email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Departamento:
                <span style={{ color: "", marginLeft: "1%" }}>
                  {department && department.name && department.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label
                htmlFor="name"
                style={{ fontSize: "large", color: "" }}
              >
                Nombre:
              </label>
              <InputText
                id="name"
                value={department.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-8">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={department.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/departments");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%"}}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default DepartmentForms;
